module.exports = __webpack_public_path__ + "static/media/lifestyleGuitar-small.8ea95220.jpg";